import ReactApexChart from 'react-apexcharts';
import { AnnotationTask } from '../../../../ecg/types/annotation-tasks.type';
import { donutGreen, donutOrange, donutRed } from '../../../../utils/colors';

interface Props {
  annotationTask: AnnotationTask;
}

export const OverallDonut: React.FC<Props> = ({ annotationTask }) => {
  const chartOptions = {
    chart: {
      type: 'donut' as const,
      toolbar: {
        show: false,
      },
    },
    colors: [donutGreen, donutRed, donutOrange],
    labels: ['Completed', 'To start', 'Pending'],
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
  };

  const series = [
    annotationTask.ecgDoneCount,
    annotationTask.ecgToStartCount,
    annotationTask.ecgPendingCount,
  ] as number[];

  return (
    <ReactApexChart
      options={chartOptions}
      series={series}
      type='donut'
      width='100%'
    />
  );
};
